export default __webpack_public_path__ + "static/media/S124.e4df8bab.png";